module.exports = __webpack_public_path__ + "static/media/up-arrow.1f34adbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/up-arrow.svg
// module id = 295
// module chunks = 0